import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { UserModel } from "./userStore"
import { CouponModel, CouponStoreModel } from "./couponStore"

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model("RootStore").props({
  userStore: types.optional(UserModel, {}),
  couponStore: types.optional(CouponStoreModel, {}),
})

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}
/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
